defineDs('DanskeSpil/Domain/Feature.Components.Dlo/Scripts/PlayTogetherFaq',
  [
    'Shared/Framework/Mithril/Scripts/Core/Component',
    'DanskeSpil/Domain/NumberGames/Scripts/Components/Shared/Svg/Svg',
  ],
  function (Component, Svg) {

    // Component:
    Component('play-together-faq', function (m, route, settings) {
      const root = {
        controller: function () {
          this.title = settings.faqTitle;
          this.text = settings.faqText;
          this.faqItems = settings.faqItems;
          this.openIndex = m.prop(null);

          this.toggleItem = (index, element) => {
            setTimeout(() => {
              element.hasAttribute('open') ? this.openIndex(index) : this.openIndex(null);
              const allDetails = element.closest('.play-together-faq-v2__items').querySelectorAll('details');
              allDetails.forEach((detailsEl, i) => {
                if (i !== this.openIndex()) {
                  detailsEl.removeAttribute('open');
                }
              });
            }, 0); // Force reflow
          };
        },
        view: function (controller) {
          return (
            <div className='play-together-faq-v2__wrapper mx-auto'>
              <div className='play-together-faq-v2__wrapper-inner'>
                <div className='play-together-faq-v2__header relative mb-40 md:mb-56'>
                  <h2 className='play-together-faq-v2__title text-[2.8rem] leading-[3.813rem] text-center font-bold mt-0 mb-8 md:text-[4rem] md:leading-[5.447rem] mx-auto'>{controller.title}</h2>
                  {controller.text && (
                    <div className='play-together-faq-v2__text relative text-center text-14 leading-[2.2rem] tracking-[0.05rem] font-semibold text-[#828282] md:leading-[2.4rem] mb-24 md:mb-0'>
                      {controller.text}
                    </div>
                  )}
                </div>
                <div className='play-together-faq-v2__items bg-[#EDF2F0] rounded-16'>
                  {controller.faqItems.map((item, index) => (
                    <details key={index} onclick={(e) => {
                      controller.toggleItem(index, e.currentTarget);
                    }} className='group relative faq-item border-b border-[#BDCDC8] [border-bottom-style:solid] py-16 px-24 last:border-b-0'>
                      <summary className='[&::-webkit-details-marker]:hidden faq-item__question relative cursor-pointer text-18 font-semibold leading-[1.15] [leading-trim:both] normal-case'>
                        <span className='absolute right-0 top-1/2 -translate-y-1/2'>
                          <span className='hidden group-open:inline'>
                            <Svg src='/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#close'></Svg>
                          </span>
                          <span className='inline group-open:hidden'>
                            <Svg src='/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg#plus'></Svg>
                          </span>
                        </span>
                        <div className='pr-32'>{item.question}</div></summary>
                      <div className='faq-item__answer text-14 font-normal leading-[2.4rem] normal-case pt-16 pb-16'>
                        {m.trust(item.answer)}
                      </div>
                    </details>
                  ))}
                </div>
              </div>
            </div>
          );
        }
      };
      // Routes:
      route('/', root);
    });
  });
